import {Component, EventEmitter, forwardRef, Input, OnInit, Output, SimpleChanges, ViewChild} from '@angular/core';
import {ControlContainer, NgForm, NgModelGroup} from '@angular/forms';
import * as _ from 'lodash';
import {UnidadeService} from "../../../services/unidade/unidade.service";
import {Unidade} from "../../../core/unidade";


@Component({
    selector: 'combo-unidade',
    templateUrl: './combo-unidade.component.html',
    styleUrls: ['./combo-unidade.component.css'],
    viewProviders: [{provide: ControlContainer, useExisting: NgForm},
        {provide: ControlContainer, useExisting: forwardRef(() => NgModelGroup)}],
})
export class ComboUnidadeComponent implements OnInit {

    @ViewChild('comboUnidade', {static: false}) comboUnidade;

    @Input() showDisplayId;
    @Input() obrigatorio;
    @Input() selecionado;
    @Input() desabilitado;

    @Output() valorChange = new EventEmitter();

    dados = [];
    data: any = {};

    constructor(private unidadeService: UnidadeService) {
    }

    ngOnInit(): void {
        this.data = Date.now();

        setTimeout(() => {
            this.unidadeService.getAllCombo().subscribe((unidades: Unidade[]) => {
                this.dados = unidades;
                this.preencherCombo();
            });
        }, 0)

    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes["selecionado"] && this.selecionado && this.selecionado.id) {
            this.preencherCombo();
        }
    }

    private preencherCombo() {
        if (this.selecionado && this.selecionado.id && this.dados.length) {
            this.selecionado = _.find(this.dados, {id: this.selecionado.id});
        }
    }

    onValorChange(registro: any) {
        this.valorChange.emit(registro);
        this.preencherCombo();
    }

}
